
import { Component, Prop, Vue } from 'vue-property-decorator';
import { importUsers, importQywxUser } from '@/api/users';
import { importDept } from '@/api/department';
import { importBranch } from '@/api/branch';
import { importParts, importPartsNew } from '@/api/parts';
import { importDevice, importBrand } from '@/api/device';
import { importFault, importFaultPhenomenon } from '@/api/fault';
import { importOrder } from '@/api/orderService';
import { importNOrder } from '@/api/order';
import { importCustomerDevice, importCustomer } from '@/api/customer';
import { UserModule } from '../../../store/modules/user';
import { getUserToken } from '@/utils/cookies';
import { hexSha1 } from '@/utils/sha1';
import { importEvent } from '@/api/orderPolling';
import { importCustomAddress } from '@/api/custom';
import { importStock, importStockNew } from '@/api/stock';
import { checkPermissionUseAndCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';
// OrderPolling/importEvent

const APP_ID = 'app_id';
const ORDER_ID = 'order_id';
const USER_ID = 'user_id';
const COMPANY_ID = 'main_company';
const TIMESTAP = 'timestamp';
const SIGN = 'sign';
const USERTOKEN = 'userToken';
const APP_ID_VALUE = 'xZZLNMmaHgdIWJwx';
const SECREKEY = 'YSsbZUVhKD7CSJbpb2ZOJCFDibwM05nl';
const AGENT = '211736';
const ALLIANCE = '221710';
const BASE_API = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_API : process.env.VUE_APP_BASE_API_DEV;
const API_ROOT = location.protocol + BASE_API;
const APPVERSION = process.env.VUE_APP_VERSION;

@Component({
  name: 'SetImport',
  components: {

  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })setImportVisible!:Boolean;
@Prop({
  type: String,
  default: '0'
})branchCompanyId!:String;
@Prop({
  type: String,
  default: '0'
})customerId!:string;
  @Prop({
    type: String,
    default: ''
  })setImportTitle!:String;
   @Prop({
     type: Object,
     default: () => ({})
   })customerImportorder!:any;
  // 1 人员 2 部门 3批量导入分公司 4 导入备件 5 导入设备 6导入故障类型 7 导入故障现象 8 批量导入订单 9 企业微信同步 10 客户授权导入设备
  // 11 导入品牌 12 导入客户 13 内报导入订单 14 导入巡检事件 15 自定义地址 16 库存 17 导入新备件
  @Prop({
    type: Number,
    default: ''
  })setImportType!:Number;
  private fileInfo:any={
    name: '',
    path: ''
  };

  private isImportBtn=false;
  private isImportFinish=false;
  private importBackData:any={};
  private importBackList:any=[];
  private loading= false;

  private formOrder: any = {
    task: '',
    dept: ''
  };
  private formAuthCustomer:any={};
  private serDealDeptment=UserModule.getUserDeptList;

  private serverAddress= process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_API : process.env.VUE_APP_BASE_API_DEV
  private formdata:any = {};
  private headers:any = {}
 private url2:string = ''

 //分派任务到自己
 private isShowIsSelf=false;
 created() {
   this.headers = {
     // 'content-type': 'application/x-www-form-urlencoded',
     // 'cache-control': 'no-cache',
     //  'content-type': 'multipart/form-data', // 默认值
     'sourceCode': '100101',
     'platformCode': '103000',
     'deviceType': 'web',
     'appVersion': process.env.VUE_APP_VERSION,
     'userToken': '',
     'deviceId': 'webid'
   };
   let token :any = getUserToken();
   if (token) {
     if (typeof token !== 'object') {
       token = JSON.parse(token as string);
     }
   }
   if (token && token.token) {
     this.headers.userToken = token.token;
   }
   let url = API_ROOT;
   switch (this.setImportType) {
     case 1:
     case 2:
       this.url2 = 'User/uploadFile';
       break;
     case 3:
       this.url2 = 'Branch/uploadFile';
       break;
     case 4:
     case 17:
       this.url2 = 'Parts/uploadFile';
       break;
     case 10:
     case 5:
       this.url2 = 'Device/uploadFile';
       break;
     case 6:
     case 7:
       this.url2 = 'Fault/uploadFile';
       break;
     case 8:
       this.url2 = 'OrderService/uploadFile';
       break;
     case 9:
       this.url2 = 'UserSync/uploadQywxFile';
       break;
     case 11:
       this.url2 = 'Device/uploadFile';
       break;
     case 12:
       this.url2 = 'Customer/uploadFile';
       break;
     case 13:
       this.url2 = 'Order/uploadFile';
       break;
     case 14:
       this.url2 = 'OrderPolling/uploadFile';
       break;
     case 15:
       this.url2 = 'CustomAddress/uploadFile';
       break;
     case 16:
     case 18:
       this.url2 = 'Stock/uploadFile';
       break;
   }
   this.serverAddress = url + this.url2;

    this.isShowIsSelf = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.IsSelfTask);
    //遍历UserModule.getUserDeptList找到dept_type=2的项
    this.serDealDeptment = UserModule.getUserDeptList.filter((item:any) => {
      return parseInt(item.dept_type) === 2;
    });
    //如果长度为1默认选中
 }

 private sendSelfTaskHandle(val:any){

    if (val && this.formOrder.task && (this.serDealDeptment && this.serDealDeptment.length == 1) ) {
      this.formOrder.dept = this.serDealDeptment[0];
    }
    // else{
    //   this.formOrder.dept = '';
    // }
  }

 //
 /**
 * 计算签名
 * @param urlName 接口名称 必填
 * @param order_id  选填
 * @param user_id 选填
 * @param company_id 选填
 * @returns {String}
 */
 private sign(url: string, orderIdddd: string, userIdddd: string, companyIdddd: string) {
   let list = [];
   let appid = this.paramSignAppend(APP_ID, APP_ID_VALUE);
   if (!this.isEmpty(appid)) {
     list.push(appid);
   }
   let orderid = this.paramSignAppend(ORDER_ID, orderIdddd);
   if (!this.isEmpty(orderid)) {
     list.push(orderid);
   }
   let userid = this.paramSignAppend(USER_ID, userIdddd);
   if (!this.isEmpty(userid)) {
     list.push(userid);
   }
   let companyid = this.paramSignAppend(COMPANY_ID, companyIdddd);
   if (!this.isEmpty(companyid)) {
     list.push(companyid);
   }
   let timestap = this.paramSignAppend(TIMESTAP, String(Date.parse(String(new Date())) / 1000));
   if (!this.isEmpty(timestap)) {
     list.push(timestap);
   }
   let temp = url + SECREKEY + list.sort().join('');
   let temp2 = hexSha1(temp);
   return temp2.toLowerCase();
 }

 private paramAppend(k: string, v: string) {
   let r = '';
   if (!this.isEmpty(v)) {
     r = k + '=' + v;
   }
   return r;
 }

 private paramSignAppend(k: string, v: string) {
   let r = '';
   if (!this.isEmpty(v)) {
     r = (k + v);
   }
   return r;
 }
 private isEmpty(str: any) {
   return str === '' || str == null;
 }

 //

 private close() {
   this.resetUpload();
   this.$emit('close', false);
 }
 private finishImport() {
   this.resetUpload();
   this.$emit('close', false);
 }

 // 导入
 private importData() {
   if (!this.fileInfo || !this.fileInfo.path) {
     this.$notify({
       title: '提示',
       message: '请上传文件',
       offset: 100,
       type: 'error'
     });
     return;
   }
   this.loading = true;
   let params:any = {};
   params.user_id = UserModule.getUserId;
   params.company_id = UserModule.getCompanyId;
   params.user_name = UserModule.getUserName;
   params.company_name = UserModule.getCompanyName;
   params.path = this.fileInfo.path;
   params.vip_level = (UserModule.getCompany as any).vip_level;

   this.isImportBtn = true;

   (this.$refs.upload as any).clearFiles();
   switch (this.setImportType) {
     case 1:
       importUsers(params).then(res => {
         //  if (res.data) {
         this.loading = false;
         //  this.importBackData = res.data;
         this.isImportFinish = true;
         this.jumpImportTask();
         //  this.importBackList = this.importBackList.concat(res.data.error_data);
         //  this.importBackList = this.importBackList.concat(res.data.success_data);
         //  }
       }).catch(err => {
         this.isImportBtn = false;
         this.$notify({
           title: '提示',
           message: err.msg,
           offset: 100,
           type: 'error'
         });
       });
       break;
     case 2:
       importDept(params).then(res => {
         this.loading = false;
         this.isImportFinish = true;
         this.jumpImportTask();
       }).catch(err => {
         this.loading = false;
         this.isImportBtn = false;
         this.$notify({
           title: '提示',
           message: err.msg,
           offset: 100,
           type: 'error'
         });
       });
       break;
     case 3:
       if (parseInt(this.branchCompanyId as string) !== 0) {
         params.branch_company_id = this.branchCompanyId;
       }
       importBranch(params).then(res => {
         if (res.data) {
           this.loading = false;
           this.importBackData = res.data;
           this.isImportFinish = true;
           this.importBackList = this.importBackList.concat(res.data.error_data);
           this.importBackList = this.importBackList.concat(res.data.success_data);
         }
       }).catch(err => {
         this.isImportBtn = false;
         this.$notify({
           title: '提示',
           message: err.msg,
           offset: 100,
           type: 'error'
         });
       });
       break;
     case 4:
       importParts(params).then(res => { // 备件导入
         //  if (res.data) {
         this.loading = false;
         //  this.importBackData = res.data;
         this.isImportFinish = true;
         this.jumpImportTask();
         //  this.importBackList = this.importBackList.concat(res.data.error_data);
         //  this.importBackList = this.importBackList.concat(res.data.success_data);
         //  }
       }).catch(err => {
         this.isImportBtn = false;
         this.$notify({
           title: '提示',
           message: err.msg,
           offset: 100,
           type: 'error'
         });
       });
       break;
     case 17:
       importPartsNew(params).then(res => { // 新备件导入
         this.loading = false;
         this.isImportFinish = true;
         this.jumpImportTask();
       }).catch(err => {
         this.isImportBtn = false;
         this.$notify({
           title: '提示',
           message: err.msg,
           offset: 100,
           type: 'error'
         });
       });
       break;
     case 5:
       importDevice(params).then(res => { // 设备导入
         //  if (res.data) {
         this.loading = false;
         //  this.importBackData = res.data;
         this.isImportFinish = true;
         this.jumpImportTask();
         //  this.importBackList = this.importBackList.concat(res.data.error_data);
         //  this.importBackList = this.importBackList.concat(res.data.success_data);
         //  }
       }).catch(err => {
         this.isImportBtn = false;
         this.$notify({
           title: '提示',
           message: err.msg,
           offset: 100,
           type: 'error'
         });
       });
       break;
     case 6:
       importFault(params).then(res => { // 故障类型
         //  if (res.data) {
         this.loading = false;
         //  this.importBackData = res.data;
         this.isImportFinish = true;
         this.jumpImportTask();
         //  this.importBackList = this.importBackList.concat(res.data.error_data);
         //  this.importBackList = this.importBackList.concat(res.data.success_data);
         //  }
       }).catch(err => {
         this.isImportBtn = false;
         this.$notify({
           title: '提示',
           message: err.msg,
           offset: 100,
           type: 'error'
         });
       });
       break;
     case 7:
       importFaultPhenomenon(params).then(res => { // 故障现象
         //  if (res.data) {
         this.loading = false;
         //  this.importBackData = res.data;
         this.isImportFinish = true;
         this.jumpImportTask();
         //  this.importBackList = this.importBackList.concat(res.data.error_data);
         //  this.importBackList = this.importBackList.concat(res.data.success_data);
         //  }
       }).catch(err => {
         this.isImportBtn = false;
         this.$notify({
           title: '提示',
           message: err.msg,
           offset: 100,
           type: 'error'
         });
       });
       break;
     case 8:
       if (this.customerImportorder && parseInt(this.customerImportorder.customer_type) === 1) {
         params.customer_id = this.customerImportorder.customer_company_id;
         params.customer_name = this.customerImportorder.name;
       } else {
         params.customer_id = 'p' + this.customerImportorder.customer_user_id;
         params.customer_name = this.customerImportorder.name;
       }
       if (this.formOrder.task && (this.serDealDeptment && this.serDealDeptment.length > 0) && (!this.formOrder.dept || !this.formOrder.dept.dept_id)) {
         this.showErrorMsg('请选择自己的部门');
         return;
       }
       if (this.formOrder.task) {
         params.import_allot_dept_state = 1;
         params.import_allot_dept_id = this.formOrder.dept.dept_id;
         params.import_allot_dept_name = this.formOrder.dept.name;
       }
       importOrder(params).then(res => {
         this.loading = false;
         this.isImportFinish = true;
         this.jumpImportTask();
         //  this.importBackData = res.data;
         //  this.isImportFinish = true;
         //  this.importBackList = this.importBackList.concat(res.data.error_data);
         //  this.importBackList = this.importBackList.concat(res.data.success_data);
       }).catch(err => {
         this.isImportBtn = false;
         this.$notify({
           title: '提示',
           message: err.msg,
           offset: 100,
           type: 'error'
         });
       });
       break;
     case 13:
       if (this.formOrder.task && (this.serDealDeptment && this.serDealDeptment.length > 0) && (!this.formOrder.dept || !this.formOrder.dept.dept_id)) {
         this.showErrorMsg('请选择自己的部门');
         return;
       }
       if (this.formOrder.task) {
         params.import_allot_dept_state = 1;
         params.import_allot_dept_id = this.formOrder.dept.dept_id;
         params.import_allot_dept_name = this.formOrder.dept.name;
       }
       importNOrder(params).then(res => {
         this.loading = false;
         this.isImportFinish = true;
         this.jumpImportTask();
         //  this.importBackData = res.data;
         //  this.isImportFinish = true;
         //  this.importBackList = this.importBackList.concat(res.data.error_data);
         //  this.importBackList = this.importBackList.concat(res.data.success_data);
       }).catch(err => {
         this.isImportBtn = false;
         this.$notify({
           title: '提示',
           message: err.msg,
           offset: 100,
           type: 'error'
         });
       });
       break;
     case 9:
       importQywxUser(params).then((res:any) => {
         this.loading = false;
         this.resetUpload();
         this.$emit('close', false);
         this.showSecussMsg(res.msg);
         this.$emit('QyFinish', res.data);
       }).catch(err => {
         this.resetUpload();
         this.$emit('close', false);
         this.$emit('QyFail', err);
       });
       break;
     case 10:
       if (!this.customerId || parseInt(this.customerId) === 0) {
         return;
       }
       params.customer_id = this.customerId;
       params.start_time = this.formAuthCustomer.start;
       params.warranty_period = this.formAuthCustomer.period;
       params.manufacturer_warranty_state = this.formAuthCustomer.original ? '1' : '0';
       importCustomerDevice(params).then(res => {
         //  if (res.data) {
         this.loading = false;
         //  this.importBackData = res.data;
         this.isImportFinish = true;
         this.jumpImportTask();
         //  this.importBackList = this.importBackList.concat(res.data.error_data);
         //  this.importBackList = this.importBackList.concat(res.data.success_data);
         //  }
       }).catch(err => {
         this.isImportBtn = false;
         this.$notify({
           title: '提示',
           message: err.msg,
           offset: 100,
           type: 'error'
         });
       });
       break;
     case 11:
       importBrand(params).then(res => { // 品牌导入
         //  if (res.data) {
         this.loading = false;
         //  this.importBackData = res.data;
         this.isImportFinish = true;
         this.jumpImportTask();
         //  this.importBackList = this.importBackList.concat(res.data.error_data);
         //  this.importBackList = this.importBackList.concat(res.data.success_data);
         //  }
       }).catch(err => {
         this.isImportBtn = false;
         this.$notify({
           title: '提示',
           message: err.msg,
           offset: 100,
           type: 'error'
         });
       });
       break;
     case 12:
       if (this.customerId) {
         params.pid = this.customerId;
       }
       importCustomer(params).then(res => {
         this.loading = false;
         this.isImportFinish = true;
         this.jumpImportTask();
       }).catch(err => {
         this.loading = false;
         this.isImportBtn = false;
         this.$notify({
           title: '提示',
           message: err.msg,
           offset: 100,
           type: 'error'
         });
       });
       break;
     case 14:
       importEvent(params).then(res => {
         this.loading = false;
         this.isImportFinish = true;
         this.jumpImportTask();
       }).catch(err => {
         this.isImportBtn = false;
         this.$notify({
           title: '提示',
           message: err.msg,
           offset: 100,
           type: 'error'
         });
       });
       break;
     case 15:
       importCustomAddress(params).then(res => { // 自定义地址
         //  if (res.data) {
         this.loading = false;
         //  this.importBackData = res.data;
         this.isImportFinish = true;
         this.jumpImportTask();
         //  this.importBackList = this.importBackList.concat(res.data.error_data);
         //  this.importBackList = this.importBackList.concat(res.data.success_data);
         //  }
       }).catch(err => {
         this.isImportBtn = false;
         this.loading = false;
         this.$notify({
           title: '提示',
           message: err.msg,
           offset: 100,
           type: 'error'
         });
       });
       break;
     case 16:
       importStock(params).then(res => { // 自定义地址
         //  if (res.data) {
         this.loading = false;
         //  this.importBackData = res.data;
         this.isImportFinish = true;
         this.jumpImportTask();
         //  this.importBackList = this.importBackList.concat(res.data.error_data);
         //  this.importBackList = this.importBackList.concat(res.data.success_data);
         //  }
       }).catch(err => {
         this.isImportBtn = false;
         this.loading = false;
         this.$notify({
           title: '提示',
           message: err.msg,
           offset: 100,
           type: 'error'
         });
       });
       break;
     case 18:
       importStockNew(params).then(res => { // 导入库存(含二级库存)
         this.loading = false;
         this.isImportFinish = true;
         this.jumpImportTask();
       }).catch(err => {
         this.isImportBtn = false;
         this.loading = false;
         this.$notify({
           title: '提示',
           message: err.msg,
           offset: 100,
           type: 'error'
         });
       });
       break;
   }
 }

 private downLoadExcel() {
   let url = '';
   switch (this.setImportType) {
     case 1:
       url = process.env.BASE_URL + 'static/frontUserNew/template/import_users.xlsx';
       break;
     case 2:
       url = process.env.BASE_URL + 'static/frontUserNew/template/import_department.xlsx';
       break;
     case 3:
       url = process.env.BASE_URL + 'static/frontUserNew/template/import_branch.xlsx';
       break;
     case 4:
       url = process.env.BASE_URL + 'static/frontUserNew/template/import_parts.xlsx';
       break;
     case 17:
       url = process.env.BASE_URL + 'static/frontUserNew/template/import_parts_new.xlsx';
       break;
     case 18:
       url = process.env.BASE_URL + 'static/frontUserNew/template/import_stock_new.xlsx';
       break;
     case 10:
     case 5:
       url = process.env.BASE_URL + 'static/frontUserNew/template/import_devices.xlsx';
       break;
     case 6:
       url = process.env.BASE_URL + 'static/frontUserNew/template/import_fault.xlsx';
       break;
     case 7:
       url = process.env.BASE_URL + 'static/frontUserNew/template/import_fault_phenomenon.xlsx';
       break;
     case 11:
       url = process.env.BASE_URL + 'static/frontUserNew/template/import_brand.xlsx';
       break;
     case 12:
       if (this.customerId) {
         url = process.env.BASE_URL + 'static/frontUserNew/template/import_customers.xlsx';
       } else {
         url = process.env.BASE_URL + 'static/frontUserNew/template/import_more_level_customers.xlsx';
       }

       break;
     case 14:
       url = process.env.BASE_URL + 'static/frontUserNew/template/import_event.xlsx';
       break;
     case 15:
       url = process.env.BASE_URL + 'static/frontUserNew/template/import_custom_address.xlsx';
       break;
     case 16:
       url = process.env.BASE_URL + 'static/frontUserNew/template/import_stock.xlsx';
       break;
   }
   window.open(url + '?time=' + new Date().getTime());
 }
 private removeUpload(remove:any) {
   this.fileInfo = {
     name: '',
     path: ''
   };
 }

 // 点击重新导入
 private resetUpload() {
   this.isImportBtn = false;
   this.isImportFinish = false;
   this.importBackData = {};
   (this.$refs.upload as any).clearFiles();
   this.fileInfo = {
     name: '',
     path: ''
   };
 }
 private beforeUpload(file:any) {
   let userid: string = UserModule.getUserId;
   let companyid: string = UserModule.getCompanyId;
   let timestap = Date.parse(String(new Date())) / 1000;
   if (!this.isEmpty(companyid)) {
     this.formdata = {
       'app_id': APP_ID_VALUE,
       'user_id': userid,
       'main_company': companyid,
       'sign': this.sign(this.url2, '', userid, companyid),
       'agent_code': AGENT,
       'alliance_code': ALLIANCE,
       'timestamp': timestap };
   } else {
     this.formdata = {
       'app_id': APP_ID_VALUE,
       'user_id': userid,
       'sign': this.sign(this.url2, '', userid, ''),
       'agent_code': AGENT,
       'alliance_code': ALLIANCE,
       'timestamp': timestap };
   }
   let promise = new Promise((resolve) => {
     this.$nextTick(function() {
       resolve(true);
     });
   });
   return promise; // 通过返回一个promis对象解决
 }
 private successUpload(success:any) {
   if (success.code === 0) {
     this.fileInfo = success.data;
   } else {
     this.resetUpload();
     this.$notify({
       title: '提示',
       message: success.msg,
       offset: 100,
       type: 'error'
     });
   }
 }
 private jumpImportTask() {
   let routeData = this.$router.resolve({
     path: '/ImportTask',
     query: {}
   });
   window.open(routeData.href);
 }
 private showErrorMsg(msg: string) {
   this.$notify({
     title: '提示',
     message: msg,
     offset: 100,
     type: 'error'
   });
 }
 private showSecussMsg(msg: string) {
   this.$notify({
     title: '提示',
     message: msg,
     offset: 100,
     type: 'success'
   });
 }
}

